import { i18n } from "@/locale";
import store from "@/store";
const { t: $t } = i18n.global;

export default [
    {
        path: "/oem",
        name: "oem__root__",
        redirect: {
            name: "oem-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "oem",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "oem-index",
                component: () => import("@/views/oem/index.vue"),
                meta: {
                    title: $t("nav.control"),
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/oem/order",
        name: "oem-order",
        redirect: "/oem/order/mine",
        component: () => import("@/layouts/default.vue"),
        beforeEnter: (to, from, next) => {
            store.dispatch("goods/loadCategories");
            next();
        },
        meta: {
            title: $t("nav.oem.order_management.name"),
            parent: "oem",
            icon: "oem-order",
            permission: "oem_customer",
        },
        children: [
            {
                path: "create",
                name: "oem-order-create",
                component: () => import("@/views/oem/create.vue"),
                meta: {
                    title: $t("nav.oem.order_management.new"),
                    icon: "oem-order-create",
                },
            },
            {
                path: ":id/edit",
                name: "oem-order-edit",
                component: () => import("@/views/oem/edit.vue"),
                hidden: true,
                meta: {
                    title: $t("nav.oem.order_management.edit"),
                    activeMenu: "/oem/order/mine",
                },
            },
            {
                path: ":id",
                name: "oem-order-detail",
                component: () => import("@/views/oem/detail.vue"),
                hidden: true,
                meta: {
                    title: $t("nav.oem.order_management.detail"),
                    activeMenu: "/oem/order/mine",
                },
            },
            {
                path: "mine",
                name: "oem-order-mine",
                component: () => import("@/views/oem/mine.vue"),
                meta: {
                    title: $t("nav.oem.order_management.mine"),
                    icon: "oem-my-order",
                },
            },
            {
                path: "bill",
                name: "oem-order-bill",
                component: () => import("@/views/fms/bill/oem-card-log.vue"),
                meta: {
                    title: $t("nav.oem.order_management.bill"),
                    icon: "oem-my-transfer",
                    mine: true,
                },
            },
        ],
    },
    {
        path: "/oem/inventory",
        name: "oem-inventory",
        redirect: "/oem/inventory",
        component: () => import("@/layouts/default.vue"),
        meta: {
            title: $t("nav.oem.inventory.name"),
            parent: "oem",
            icon: "oem-inventory",
        },
        children: [
            {
                path: "main",
                name: "oem-inventory-main",
                component: () => import("@/views/fms/produce/oem_inventory/index.vue"),
                meta: {
                    title: $t("nav.oem.inventory.mine"),
                    icon: "oem-my-inventory",
                    mine: true,
                },
            },
            // {
            //     path: "inv-adjust",
            //     name: "oem-inv-adjust",
            //     component: () => import("@/views/fms/produce/inv_adjust/index.vue"),
            //     meta: {
            //         title: $t("nav.oem.inventory.adjust"),
            //         icon: "prod-stock-record",
            //         affix: false,
            //     },
            // },
        ],
    },
];
